module.exports = __webpack_public_path__ + "img/avatar0.4eae0095.png";